module.exports = __webpack_public_path__ + "img/historyImg3.be130295.jpg";